import { render, staticRenderFns } from "./ListBenhAn.vue?vue&type=template&id=dacf9a9a&scoped=true"
import script from "./ListBenhAn.vue?vue&type=script&lang=js"
export * from "./ListBenhAn.vue?vue&type=script&lang=js"
import style0 from "./ListBenhAn.vue?vue&type=style&index=0&id=dacf9a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacf9a9a",
  null
  
)

export default component.exports